/**
 * Community-standards acknowledgment API client (voice-ladder gate,
 * Skip ruling 2026-07-07; §7.5 as amended).
 *
 * Wraps POST /api/auth/accept-standards — the persistence behind the
 * Getting-started "Read this: community standards" act. Mirrors
 * src/api/eula.ts exactly, including the cache-invalidation side effect.
 */

import { apiFetch } from './client';
import { invalidateAndRefetch, QUERY_KEYS } from './queryCache';
import { invalidateOnboardingState } from './onboarding';

export interface AcceptStandardsResponse {
  communityStandardsAcceptedAt: string;
  communityStandardsVersionAccepted: number;
}

/**
 * Submit the user's acknowledgment of the given standards version.
 *
 * Side effect: invalidates the security cache (same rule as acceptEula —
 * must be `invalidateAndRefetch`, never a raw event dispatch) so
 * useApiSecurityData picks up the new acknowledgment fields, the
 * Getting-started row completes, and the org-feed composer unlocks.
 */
export async function acceptStandards(version: number): Promise<AcceptStandardsResponse> {
  const result = await apiFetch<AcceptStandardsResponse>('/api/auth/accept-standards', {
    method: 'POST',
    body: JSON.stringify({ version }),
  });

  invalidateAndRefetch(QUERY_KEYS.security);
  // Standards currency is a rung basic — this accept can complete the
  // Explorer→Contributor promotion; App.tsx's onboarding instance must
  // hear about it live so the celebration popup fires (2026-07-08).
  invalidateOnboardingState();

  return result;
}
